class InitialInquiryInput {
    static init($context = null) {
        let selector = '[data-initial-inquiry]';
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if($(element).data('initial_inquiry_input_instance')) return;
            $(element).data('initial_inquiry_input_instance', new InitialInquiryInput(element))
        });
    }

    constructor(element) {
        this.element = element;
        this.$element = $(element);
        this.$initialInquiryCheckbox = $('[data-input="initial_inquiry"]')

        if (this.$initialInquiryCheckbox && this.$initialInquiryCheckbox.length > 0) {
            let action = this.$element.data('initial-inquiry');

            if(action === 'hide'){
                this.initHideEvents();
            }

            if(action === 'show'){
                this.initShowEvents();
            }
        }
    }

    initHideEvents() {
        this.$initialInquiryCheckbox.on('change', (event) => {
            this.$element.toggle(!$(event.target).is(':checked'));
        });
    }

    initShowEvents() {
        this.$initialInquiryCheckbox.on('change', (event) => {
            this.$element.toggle(!$(event.target).is(':checked'));
        });
    }
}

InitialInquiryInput.init();
//node modules support
module.exports = InitialInquiryInput;